import React from "react"
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import * as api from "api";

import Page from "../Page";
import UsersTable from "./UsersTable";
import useDataTable from "../../components/DataTable/useDataTable";

import MDBox from "materialDashboard/components/MDBox";
import MDButton from "materialDashboard/components/MDButton";
import Card from "@mui/material/Card";
import {useAuth} from "../../auth/AuthProvider";
import ExportToolbar from "./ExportToolbar";


const Users = () => {
    const {t} = useTranslation(['users']);
    const navigate = useNavigate();
    const {workgroupAuthorization} = useAuth();

    const {fetchDataOptions, ...tableState} = useDataTable({
        dataTableId: "users",
        initialFiltersValue: {is_active__in: 'true'}
    });

    const dataOptions = {
        ...fetchDataOptions,
        orderBy: tableState.sorting
            .map(({id, desc}) => id === "user" ? ({id: 'surname', desc}) : ({id, desc}))  // when sorting by user use the surname
            .map(({id, desc}) => `${desc ? "+" : "-"}${id}`).join(",")
    }

    const dataQuery = useQuery({
        queryKey: ['users', dataOptions],
        queryFn: () => api.User.getUsers(dataOptions),
        keepPreviousData: true
    })

    return <Page path={"/users"}>
        <MDBox mx={2}>
            <MDBox mb={2}>
                {
                    workgroupAuthorization.users.create &&
                    <MDButton variant="gradient" color="info" onClick={() => navigate("/users/new")}>
                        {t('newUser')}
                    </MDButton>
                }
            </MDBox>
            <Card>
                <UsersTable rows={dataQuery.data?.rows}
                            page_count={dataQuery.data?.page_count}
                            showRowColoring
                            {...tableState}/>
                <ExportToolbar userFilter={dataOptions} />
            </Card>
        </MDBox>
    </Page>

}


export default Users;